module.exports = require("cytoscape-edgehandles");